import React, {useMemo} from "react";

import useAuth from "../login/AuthContext";

import Switch from '@mui/material/Switch';
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { MainLayout } from "../../layout/MainLayout";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { UserSearchResultsTable } from "../../components/UserSearchResultsTable";
import { UserSearchByNameForm } from "../../components/UserSearchByNameForm";
import { UserSearchByPinForm } from "../../components/UserSearchByPinForm";
import { UserSearchByUserIdForm } from "../../components/UserSearchByUserIdForm";

export const UsersSearchPage = () => {
  const { isRms, isEntrata, isAcc } = useSelectedNetworkImportTypes();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { isSuperAdmin } = useAuth();
  const [ showArchived, setShowArchived ] = React.useState(false);
  const [results, setResults] = React.useState<any[]>([]);
  const [isPinSearch, setPinSearch] = React.useState(true);

  const nonArchivedResults =  useMemo(() => {
    return results.filter(result => result.matchingRoundStatus !== "ARCHIVED");
  }, [results, setResults]);
  const archivedResults = useMemo(() => {
    return results.filter(result => result.matchingRoundStatus === "ARCHIVED");
  }, [results, setResults]);

  React.useEffect(() => {
    setPinSearch(isRms || isEntrata || (isAcc && isSuperAdmin()));
  }, [selectedNetworkId]);

  const handleTogglChange = (_: any, checked: boolean) =>setShowArchived(checked);

  return (
    <MainLayout
      title="Search By Name"
      endAdornment={
        <Grid container justifyContent="flex-end" alignItems="center">
          <Typography> Show Archived
            <Switch value={showArchived} onChange={handleTogglChange}/>
          </Typography>
        </Grid>
        }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <UserSearchByNameForm onSuccess={setResults} />
        </Grid>
        {isPinSearch && (
          <Grid item xs={12}>
            <UserSearchByPinForm onSuccess={setResults} />
          </Grid>
        )}
        {isSuperAdmin() && (
          <Grid item xs={12}>
            <UserSearchByUserIdForm onSuccess={setResults} />
          </Grid>
        )}
        <Grid item xs={12} my={4}>
          <UserSearchResultsTable isGlobalSearch results={nonArchivedResults} />
        </Grid>
        {
          archivedResults.length > 0 && showArchived && (
            <Grid item xs={12} my={4}>
              <Typography mb={2}>
                Archived Users
              </Typography>
              <UserSearchResultsTable isGlobalSearch results={archivedResults} />
            </Grid>
          )
        }
      </Grid>
    </MainLayout>
  );
};

export const USERS_SEARCH_URL = "/users/search";
